import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.currentSupply = null
    this.clearMessages()
  }

  async handleScan(event) {
    event.preventDefault()
    const scanInput = event.target
    const barcode = scanInput.value.trim()

    if (!barcode) return

    // Clear input for next scan
    scanInput.value = ''

    // Hide previous messages
    this.clearMessages()

    try {
      const response = await fetch('/supply_station/scan', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: JSON.stringify({ scan_input: barcode })
      })

      const data = await response.json()

      if (response.ok) {
        this.displaySupply(data.supply, data.default_quantity)
      } else {
        this.showError(data.error || 'Unknown error occurred')
      }
    } catch (error) {
      this.showError('Network error: ' + error.message)
    }

    // Refocus on scan input
    scanInput.focus()
  }

  displaySupply(supply, defaultQuantity = 1) {
    this.currentSupply = supply

    // Display supply info
    document.getElementById('supply-product-name').textContent = supply.product_name
    document.getElementById('supply-sku').textContent = `SKU: ${supply.sku}`
    document.getElementById('supply-quantity').textContent = supply.display_quantity

    // Set default quantity
    document.getElementById('quantity-input').value = defaultQuantity

    // Show/hide stock alerts
    if (supply.out_of_stock) {
      document.getElementById('out-of-stock-alert').classList.remove('hidden')
      document.getElementById('low-stock-alert').classList.add('hidden')
    } else if (supply.low_stock) {
      document.getElementById('low-stock-alert').classList.remove('hidden')
      document.getElementById('out-of-stock-alert').classList.add('hidden')
      const message = `Only ${supply.display_quantity} remaining. Reorder point: ${supply.reorder_point}`
      document.getElementById('low-stock-message').textContent = message
    } else {
      document.getElementById('low-stock-alert').classList.add('hidden')
      document.getElementById('out-of-stock-alert').classList.add('hidden')
    }

    // Show supply display
    document.getElementById('supply-display').classList.remove('hidden')
  }

  async addQuantity() {
    await this.adjustQuantity('add')
  }

  async removeQuantity() {
    await this.adjustQuantity('remove')
  }

  async adjustQuantity(actionType) {
    if (!this.currentSupply) {
      this.showError('No supply selected')
      return
    }

    const quantity = parseInt(document.getElementById('quantity-input').value)
    if (quantity < 1) {
      this.showError('Quantity must be at least 1')
      return
    }

    this.clearMessages()

    try {
      const response = await fetch('/supply_station/adjust', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: JSON.stringify({
          supply_id: this.currentSupply.id,
          quantity_change: quantity,
          action_type: actionType
        })
      })

      const data = await response.json()

      if (response.ok) {
        this.showSuccess(data.message)

        // Update displayed quantity
        document.getElementById('supply-quantity').textContent = data.supply.display_quantity

        // Update stock alerts
        if (data.supply.low_stock) {
          document.getElementById('low-stock-alert').classList.remove('hidden')
        } else {
          document.getElementById('low-stock-alert').classList.add('hidden')
        }

        // Reset quantity input
        document.getElementById('quantity-input').value = 1

        // Clear display after 3 seconds
        setTimeout(() => {
          this.clearDisplay()
        }, 3000)
      } else {
        this.showError(data.error || 'Failed to adjust quantity')
      }
    } catch (error) {
      this.showError('Network error: ' + error.message)
    }

    // Refocus on scan input
    document.getElementById('scan_input').focus()
  }

  showSuccess(message) {
    const successDiv = document.getElementById('success-message')
    document.getElementById('success-text').textContent = message
    successDiv.classList.remove('hidden')

    setTimeout(() => {
      successDiv.classList.add('hidden')
    }, 5000)
  }

  showError(message) {
    const errorDiv = document.getElementById('error-message')
    document.getElementById('error-text').textContent = message
    errorDiv.classList.remove('hidden')

    setTimeout(() => {
      errorDiv.classList.add('hidden')
    }, 5000)
  }

  clearMessages() {
    document.getElementById('success-message').classList.add('hidden')
    document.getElementById('error-message').classList.add('hidden')
  }

  clearDisplay() {
    document.getElementById('supply-display').classList.add('hidden')
    this.currentSupply = null
    this.clearMessages()
  }
}
